
<div class="modal-dialog">
  <div class="modal-content" style="width: 600px; left: -10%;">
    <form #dartDealDialogForm="ngForm" (ngSubmit)="importDealKey()">
      <div class="modal-header">
        <h4 class="modal-title">{{ CPQSource ? 'Import deal from SAP CPQ' : 'Import DART Deal' }}</h4>
        <button class="close" type="button" (click)="close()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error" [guideLink]="'billingTermsGuideLink' | appSetting"></error>
        <success></success>
        <div *ngIf="processing">
          <md-spinner-block></md-spinner-block>
        </div>
        <div class="form-group">
          <div class="row">
            <div class="col">
              <label for="dealKey">{{ CPQSource ? 'Deal(s) key(s)' : 'DART Deal(s) key(s)' }}</label><small style="float:right">separated by commas*</small>
              <input class="form-control" id="dealKey" type="text" [(ngModel)]="dartDealKey" name="dealKey" [disabled]="processing">
            </div>
          </div>
          <div class="row mt-2" *ngIf="displayTargetSystem">
            <div class="col">
              <label class="required">Target System</label>
              <select class="form-control" id="targetSystem" name="targetSystem" [(ngModel)]="targetSystem" autoLinkToLabel>
                <option value="legacy">Legacy</option>
                <option value="pmpsc">Partner MPS</option>
                <option value="daas">DAAS</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-primary" type="submit" [disabled]="processing">Import</button>
        <button class="btn btn-outline-secondary" type="button" (click)="close()">Close</button>
      </div>
    </form>
  </div>
</div>